import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/front/13_classic-3/13_classic-3"
 * Contains 12 texture(s)
 */
export class CardsFront13Classic3Atlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/front/13_classic-3/13_classic-3';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '4-spades.png',
        '4-hearts.png',
        '4-diamonds.png',
        '4-clubs.png',
        '3-spades.png',
        '3-hearts.png',
        '3-diamonds.png',
        '3-clubs.png',
        '2-spades.png',
        '2-hearts.png',
        '2-diamonds.png',
        '2-clubs.png'
    ] as const;
}
